module.exports = __webpack_public_path__ + "static/media/ews.151050de.png";